import {Component, OnInit, ViewChild} from '@angular/core';
import {Grid} from '../../../../shared/Models/grid';
import {concat, Observable, of, Subject} from 'rxjs';
import {Supplier} from '../../../Models/Supplier';
import {Property} from '../../../Models/Property';
import {Router} from '@angular/router';
import {PropertyService} from '../../../Services/property.service';
import {TranslateService} from '@ngx-translate/core';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {ActionColumn, ActionItem, TextColumn} from '../../../../shared/Models/columns';
import {HttpParams} from '@angular/common/http';
import {catchError, debounceTime, distinctUntilChanged, filter, switchMap, tap} from 'rxjs/operators';

@Component({
  selector: 'app-archive-property-view',
  templateUrl: './archive-property-view.component.html',
  styleUrls: ['./archive-property-view.component.scss']
})
export class ArchivePropertyViewComponent implements OnInit {

  public grid: Grid;
  public propertyId: number;
  public propertyName: string;
  public properties: Observable<Supplier[]>;
  public propertiesLoading = false;
  public propertiesinput$ = new Subject<string>();
  public selectedProperty: Property;
  @ViewChild('propertyRowDetail', {static: false}) propertyRowDetail: any;
  @ViewChild('readdModel', {static: false}) readdModel = null;

  constructor(private router: Router, private propertyService: PropertyService, private translate: TranslateService ,private broadcastService: BroadcastService) {
  }

  ngOnInit() {
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.property.name',
          prop: 'name',
          sortable: true,
          type: TextColumn.type,
          translate: true
        },
        <TextColumn>{
          name: 'doctrine.property.description',
          prop: 'description',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          responsiveHideCallback: (width) => width < 1024
        },
        <TextColumn>{
          name: 'doctrine.property.status',
          prop: 'status',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => {
            if (row) {
              return this.translate.instant(Property.PROPERTY_AMOUNT);
            }
            return this.translate.instant(Property.PROPERTY_METERS);
          }
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'feather icon-plus',
              tooltip: 'global.readd',
              onclick: row => {
                this.propertyId = row.id;
                this.propertyName = row.name.bold();
                this.readdModel.show();
                // return this.router.navigateByUrl('back-office/property/' + row.id + '/show');
              },
              showCallback: row => row,
              btnClass: 'ripple light'
            },
          ]
        }
      ],
      service: this.propertyService,
      rememberURL: this.router.url,
      method: 'getProperty',
      defaultSort: 'name',
      rowDetailTemplate: this.propertyRowDetail,
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: true,
      archive: true,
    };
  }

  reAdd() {
    this.propertyService.reAdd(this.propertyId).subscribe((res) => {
      this.broadcastService.broadcast('refreshGrid', 'getProperty');
      this.readdModel.hide();
    });
  }



}
